<template>
	<router-view name="header"></router-view>
	<router-view name="alerts"></router-view>
	<router-view></router-view>
	<router-view name="contact"></router-view>
	<router-view name="footer"></router-view>
</template>
